import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import EnquiryForm from '@/components/EnquiryForm';

export default function EnquiryPage({ user, setUser, theme, toggleTheme, accentColor, onAccentChange }) {
  return (
    <div className="min-h-screen bg-background">
      <Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} accentColor={accentColor} onAccentChange={onAccentChange} />
      <EnquiryForm />
      <Footer user={user} setUser={setUser} />
    </div>
  );
}
